import { Routes } from '@angular/router';

import { AuthGuard } from '../../core/auth.guard';
import { DetailContainerComponent } from './containers/detail-container/detail-container.component';
import { ListContainerComponent } from './containers/list-container/list-container.component';
import { DistributionComponent } from './distribution.component';

export const distributionRoutes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        component: DistributionComponent,
        children: [
            { path: '', pathMatch: 'full', redirectTo: 'distributions' },
            { path: 'distributions', component: ListContainerComponent },
            { path: 'distributions/:distributionId', component: DetailContainerComponent }
        ]
    },
];



// WEBPACK FOOTER //
// ./src/app/modules/distribution/distribution.routing.ts